import { createReducer, on } from '@ngrx/store';

import { CmsRenderState, cmsRenderState } from '../../domain/state/cms-render.state';

import {
    CmsStatusSlug, LoadSlugTreeSuccess, LoadStoreProducts,
    RemoveAllSlugs, SectionFocused, SetThemePage, ShowCountdown,
} from '@features/cms-render/domain/state/cms-render.actions';

export const cmsRenderReducer = createReducer(
    cmsRenderState,
    on(
        RemoveAllSlugs,
        (state): CmsRenderState => {
            return {
                ...state,
                pages: {},
                statusPage: null,
            };
        }
    ),
    on(
        CmsStatusSlug,
        (state, { slug, status }): CmsRenderState => {
            return {
                ...state,
                statusPage: {
                    ...state.statusPage,
                    [slug]: {
                        status,
                        showCountdown: state.statusPage?.[slug]?.showCountdown ?? false,
                    },
                },
            };
        }
    ),
    on(
        LoadSlugTreeSuccess,
        (state, {
            slug, content, isVip, tt, versionId, segmentId,
        }): any => {
            return {
                ...state,
                pages: {
                    ...state.pages,
                    [slug]: {
                        ...content, isVip, tt, slug, versionId, segmentId,
                    },
                },
            };
        }
    ),
    on(
        LoadStoreProducts,
        (state, params): any => {
            return {
                ...state,
                products: params.products,
            };
        }
    ),
    on(
        ShowCountdown,
        (state, { slug, showCountdown }): CmsRenderState => {
            let itemStatusPage = state.statusPage?.[slug];
            if (!itemStatusPage) {
                itemStatusPage = {
                    status: 'LOADING',
                    showCountdown: showCountdown,
                };
            }

            return {
                ...state,
                statusPage: {
                    ...state.statusPage,
                    [slug]: {
                        ...itemStatusPage,
                    },
                },
            };
        }
    ),
    on(
        SectionFocused,
        (state, { id, theme }): CmsRenderState => {
            return {
                ...state,
                sectionFocused: {
                    id,
                    theme,
                },
            };
        }
    ),
    on(
        SetThemePage,
        (state, { theme, titleSection }): CmsRenderState => {
            return {
                ...state,
                theme,
                titleSection,
            };
        }
    ),
);
